const insurances = {
    'unknown_uninsured': 'unknown / not insured',
    33868451: 'AKA / Augenoptiker Ausgleichskasse VVaG',
    1000080: 'AOK / Nordost in Mecklenburg-Vorpommern',
    1000126: 'AOK / Nordost in Brandenburg',
    1000159: 'AOK / PLUS in Thüringen',
    15039702: 'AOK / Hamburg RD d. AOK Rheinland/Hamburg',
    20012084: 'AOK / Bremen/Bremerhaven',
    30009013: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Mönchengladbach/Kreise Heinsberg - Viersen',
    30025400: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Städteregion Aachen Kreis Düren',
    30137494: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Städteregion Aachen Kreis Düren',
    30900193: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Oberberg - Leverkusen - Rhein.-Berg. Kreis',
    30903777: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Oberberg - Leverkusen - Rhein.-Berg. Kreis',
    32007630: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Bonn Rhein-Sieg-Kreis',
    32063968: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Bonn Rhein-Sieg-Kreis',
    32529960: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Rhein-Erft-Kreis Kreis Euskirchen',
    32591455: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Rhein-Erft-Kreis - Kreis Euskirchen',
    33932950: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Städteregion Aachen - Kreis Düren',
    34216864: 'AOK / Rheinland/Hamburg RD Düsseldorf',
    35072227: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Duisburg - Oberhausen',
    35310394: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Essen - Mülheim an der Ruhr',
    37814547: 'AOK / Rheinland/Hamburg RD Köln',
    38605421: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Mönchengladbach/Kreise Heinsberg - Viersen',
    38605513: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Kreis Kleve - Kreis Wesel',
    38615296: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Rhein-Kreis Neuss - Krefeld',
    39343643: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Rhein-Kreis Neuss - Krefeld',
    40107672: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Duisburg - Oberhausen',
    40134915: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Essen  - Mülheim an der Ruhr',
    41911974: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Wuppertal - Remscheid - Solingen',
    41912602: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Wuppertal - Remscheid - Solingen',
    42031129: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Oberberg - Leverkusen - Rhein.-Berg. Kreis',
    42507954: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Kreis Kleve - Kreis Wesel',
    42807230: 'AOK / Rheinland/Hamburg RD Kreis Mettmann',
    42938922: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Wuppertal - Remscheid - Solingen',
    51605725: 'AOK / Rheinland-Pfalz/Saarland Die Gesundheitskasse',
    55420162: 'AOK / Rheinland-Pfalz/Saarland Die Gesundheitskasse',
    90235319: 'AOK / Nordost in Berlin',
    95940768: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Mönchengladbach/ Kreise Heinsberg - Viersen',
    13460004: 'AOK / NordWest Region Schleswig-Holstein',
    45118687: 'AOK / Hessen',
    33526082: 'AOK / NordWest Region Westfalen-Lippe',
    29720865: 'AOK / Die Gesundheitskasse für Niedersachsen',
    1029141: 'AOK / Sachsen-Anhalt',
    5174740: 'AOK / PLUS in Sachsen DAV',
    34364249: 'AOK / Rheinland/Hamburg',
    67450665: 'AOK / Baden-Württemberg',
    87880235: 'AOK / Bayern Die Gesundheitskasse',
    1000672: 'BKK / Deutsche Bank AG Ost Gesch. Ber. Neue Bundesländer',
    1017272: 'BKK / Brandenburgische',
    1068979: 'BKK / Thüringer Betriebskrankenkasse',
    1085106: 'BKK / MEM',
    1085583: 'BKK / Deutsche Ost',
    1085787: 'BKK / SBK HV Ost',
    1085890: 'BKK / R+V Ost',
    15517302: 'BKK / Mobil Oil',
    15517482: 'BKK / SECURVITA',
    20156113: 'BKK / atlas BKK ahlmann',
    21203214: 'BKK / Salzgitter',
    23709856: 'BKK / 24',
    30165364: 'BKK / actimonda krankenkasse',
    30168049: 'BKK / EUREGIO',
    31209131: 'BKK / Heimat Krankenkasse',
    31323584: 'BKK / Bertelsmann AG',
    31323686: 'BKK / Diakonie',
    31323700: 'BKK / Miele',
    31323799: 'BKK / Dürkopp Adler',
    31323802: 'BKK / GILDEMEISTER SEIDENSTICKER',
    34401277: 'BKK / Deutsche Bank AG',
    35430071: 'BKK / E.ON',
    36916935: 'BKK / Melitta plus',
    37416328: 'BKK / VDN',
    40180080: 'BKK / VIACTIV',
    41378558: 'BKK / SIEMAG',
    42039708: 'BKK / Die Bergische Krankenkasse',
    44037562: 'BKK / Werra-Meissner',
    44377882: 'BKK / Merck',
    44953697: 'BKK / Salus',
    45094199: 'BKK / Braun-Gillette',
    45094601: 'BKK / Vereinigte',
    47034920: 'BKK / Henschel Plus',
    47034953: 'BKK / Herkules',
    47034975: 'BKK / B. Braun Melsungen AG',
    47307817: 'BKK / PwC',
    48063096: 'BKK / Karl Mayer',
    48698889: 'BKK / Linde',
    48944809: 'BKK / R+V',
    51588416: 'BKK / Pfaff AG Kaiserslautern',
    52598579: 'BKK / Pfalz',
    60393261: 'BKK / Groz-Beckert',
    61232758: 'BKK / Scheufelen',
    61232769: 'BKK / WMF',
    62332660: 'BKK / Südzucker',
    63494759: 'BKK / mhplus',
    63922962: 'BKK / Freudenberg',
    65710574: 'BKK / MTU',
    66105948: 'BKK / Metzinger',
    66458477: 'BKK / Die Schwenninger Krankenkasse',
    66458503: 'BKK / AESCULAP',
    67161380: 'BKK / Würth',
    67572537: 'BKK / Mahle GmbH',
    67572593: 'BKK / Bosch',
    67573219: 'BKK / Deutsche',
    68659646: 'BKK / Wieland',
    73170269: 'BKK / Textilgruppe Hof',
    74773896: 'BKK / SKD',
    75925585: 'BKK / KBA',
    81211334: 'BKK / Stadt Augsburg',
    82889062: 'BKK / AUDI',
    87271125: 'BKK / BMW Zentrale',
    87954699: 'BKK / SBK',
    16665321: 'BKK / RWE',
    22178373: 'BKK / Exklusiv',
    35087667: 'BKK / Grillo Werke',
    74157435: 'BKK / Krones',
    1073497: 'BKK / Bosch Ost',
    36916980: 'BKK / HMR/West Herford Minden Ravensberg',
    52156763: 'BKK / Debeka',
    69753266: 'BKK / ZF & Partner',
    92644250: 'BKK / VBU Verkehrsbau Union',
    1075558: 'BKK / advita Ost',
    1086050: 'BKK / EWE Ost',
    26515319: 'BKK / EWE',
    29717581: 'BKK / energie',
    30980327: 'BKK / BPW Wiehl',
    51980490: 'BKK / EVM der Energieversorgung Mittelrhein',
    60255652: 'BKK / advita',
    71579930: 'BKK / Akzo Nobel Obernburg',
    86772584: 'BKK / Faber Castell & Partner',
    20156168: 'BKK / firmus',
    33865367: 'BKK / Continentale',
    41378433: 'BKK / Achenbach Buschhütten',
    68216980: 'BKK / Daimler',
    1086312: 'BKK / actimonda krankenkasse',
    1085195: 'BKK / Salus Ost',
    1085037: 'BKK / Bertelsmann AG Ost',
    66614249: 'BKK / SBH',
    1085538: 'BKK / Salzgitter Ost',
    1058922: 'BKK / firmus Ost',
    1013837: 'BKK / Diakonie Ost',
    1085812: 'BKK / energie Ost',
    1020870: 'BKK / ZF & Partner Ost',
    1085026: 'BKK / Würth Ost',
    23446040: 'BKK / Technoform',
    3591039: 'BKK / Exklusiv Ost',
    1085457: 'BKK / Linde Ost',
    1085402: 'BKK / SECURVITA Ost',
    1086243: 'BKK / Debeka Ost',
    21488086: 'BKK / Publik-Partner der BKK Salzgitter',
    1085231: 'BKK / WMF Ost',
    97352653: 'BKK / Voralb HELLER*INDEX*LEUZE',
    5045203: 'BKK / KBA König/Bauer/Albert Ost',
    52654083: 'BKK / Vital',
    69785429: 'BKK / Verbund Plus',
    1085754: 'BKK / BMW AG Ost',
    1049156: 'BKK / Verbund Plus Ost',
    66626976: 'BKK / Rieker Ricosta Weisser',
    4309904: 'BKK / VDN Ost',
    1085823: 'BKK / Südzucker Ost',
    1085242: 'BKK / SKD Ost',
    16839984: 'BKK / Beiersdorf AG',
    46939789: 'BKK / Ernst & Young',
    1085219: 'BKK / Vereinigte Ost',
    8316149: 'BKK / Bahn Rechtskreis Ost',
    49003443: 'BKK / Bahn Rechtskreis West',
    1085082: 'BKK / Braun-Gillette Ost',
    1085446: 'BKK / Pfaff AG Kaiserslautern Ost',
    1086094: 'BKK / Heimat Krankenkasse/Ost',
    2430065: 'BKK / 24 Ost',
    7684386: 'BKK / Miele/Ost',
    7812433: 'BKK / mhplus Ost',
    46967693: 'BKK / Wirtschaft & Finanzen',
    1018182: 'BKK / HMR/Ost Herford Minden Ravensberg',
    1083422: 'BKK / Audi Ost',
    8476370: 'BKK / VBU Verkehrsbau Union Ost Gesch. Bereich Neue Länder',
    7251093: 'BKK / Pfalz Ost',
    29074470: 'BKK / TUI',
    2988673: 'BKK / Daimler Ost',
    6818233: 'BKK / Die Schwenninger Krankenkasse/Ost',
    1011777: 'BKK / GILDEMEISTER SEIDENSTICKER-Ost',
    8090728: 'BKK / ProVita/Ost_(ehem.BKK A.T.U)',
    88571250: 'BKK / ProVita (ehemals BKK A.T.U)',
    3847834: 'BKK / NOVITAS Ost',
    35134022: 'BKK / NOVITAS',
    8227948: 'BKK / TUI Ost',
    6785450: 'BKK / Wirtschaft & Finanzen Ost',
    8596570: 'BKK / PwC Ost',
    15872672: 'BKK / pronova',
    15874275: 'BKK / pronova Ost',
    97565837: 'BKK / Thüringer Betriebskrankenkasse',
    98000006: 'BUN / Knappschaft Hauptverwaltung',
    98000001: 'BUN / Knappschaft Hauptverwaltung',
    15027365: 'EK / Techniker-Krankenkasse',
    15031806: 'EK / Hanseatische Krankenkasse Hauptverwaltung',
    15035218: 'EK / DAK-Gesundheit',
    20013461: 'EK / hkk',
    29137937: 'EK / KKH Kaufmännische Krankenkasse',
    42938966: 'EK / BARMER GEK vormals Barmer Ersatzkasse',
    48698890: 'EK / DAK Gesundheit (ehem.BKK-Gesundheit)',
    66761998: 'EK / BARMER GEK vormals Gmünder Ersatzkasse',
    1031123: 'EK / DAK Gesundheit Ost (ehem.BKK-Gesundheit)',
    1000455: 'IKK / gesund plus (Ost)',
    1005483: 'IKK / Nord Ost',
    14228571: 'IKK / Nord',
    15039837: 'IKK / classic Rechtsk.West Hauptverwaltung',
    20013109: 'IKK / gesund plus (West)',
    55811201: 'IKK / Südwest',
    90397224: 'IKK / Brandenburg und Berlin Regionaldirektion Berlin',
    1020803: 'IKK / Brandenburg und Berlin Ost Regionaldirektion Brandenburg',
    5012943: 'IKK / BIG direkt gesund Ost',
    97141402: 'IKK / BIG direkt gesund West',
    1049203: 'IKK / classic Rechtsk. Ost Hauptverwaltung',
    1000308: 'LKK / SVLFG, Landw.KK, Hoppegarten Geschäftsstelle Hoppegarten',
    1000650: 'LKK / SVLFG, Landw. KK, Kassel ehemals Gartenbau, Kassel',
    13199426: 'LKK / SVLFG, Landw. KK, Kiel Geschäftsstelle Kiel',
    29147110: 'LKK / SVLFG, Landw. KK, Hannover Geschäftsstelle Hannover',
    39873587: 'LKK / SVLFG, Landw. KK, Münster Geschäftsstelle Münster',
    47068420: 'LKK / SVLFG, Landw. KK, Kassel Geschäftsstelle Kassel',
    47069693: 'LKK / SVLFG, Landw.KK, Kassel (ehemals Gartenbau) Kassel (ehemals Gartenbau)',
    67574619: 'LKK / SVLFG, Landw. KK, Stuttgart Geschäftsstelle Stuttgart',
    72360029: 'LKK / SVLFG, Landw. KK, Bayreuth Geschäftsstelle Bayreuth',
    87119868: 'LKK / SVLFG, Landw. KK, Landshut Geschäftsstelle Landshut',
    99086875: 'SEE / Knappschaft (See-Krankenvers.) Hauptverwaltung',
};

export default insurances;


// WEBPACK FOOTER //
// ./src/js/components/lists/insurances.js